module.exports = __webpack_public_path__ + "img/flowChart.2249462e.png";